<script>
    import { createEventDispatcher, afterUpdate } from 'svelte';
    import {fade} from 'svelte/transition'

    const dispatch = createEventDispatcher();

    export let isOpenModal
    export let winhistory
    export let puzzState
    export let releasedate
    export let nextpuzzledate
    export let solved
    export let seqId
 
    afterUpdate(() => {
        if(isOpenModal && solved){
            document.getElementById('sharebutton').focus();
        }
    })

    let confirmcopy = false
    let daysleftstr = "stay tuned for another ampersandi!"
    $: daysleft = Math.ceil((new Date(nextpuzzledate) - new Date()) / (3600000 * 24))
    //$: console.log(nextpuzzledate + ": " + daysleft)
    $: updateDaysLeftStr(daysleft)
    //$: console.log(puzzState)
    
    function updateDaysLeftStr(daysleft){
        //console.log(daysleft + " days left")
        if(daysleft != daysleft){ //catch NaN
            daysleftstr = "Stay tuned for another ampersandi."
        }else{
            switch(daysleft){
                case undefined:
                    daysleftstr = "Stay tuned for another puzzle."
                    break
                case 1:
                    daysleftstr = "Next ampersandi tomorrow!"
                    break
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    daysleftstr = "Next ampersandi in " + daysleft + " days."
                    break
                case 7:
                    daysleftstr = "Next ampersandi in a week."
                    break
                default:
                    daysleftstr = "Next ampersandi in over a week."
            }
        }
    }
    
    /*
        A    --8.3--
        M        &    
        P    &&&&&+
        E      &&&     
        R  S  A  N  D  I

        //ampersandi.game/?p=1

        formula for amp rows:
        four spaces (three on first row) and then
            &&&&&+ 
            one space &&&&& one space
            two spaces &&&& two spaces
            three spaces &&& three  spaces
            four spaces && four spaces
            five spaces & five spaces
    */
    async function shareResult() {
        //const d = new Date(releasedate)
        const rdsplit = releasedate.split("T")
        const dsplit = rdsplit[0].split("-")
        const puzzMonth = parseInt(dsplit[1])
        const puzzDay = parseInt(dsplit[2])

        let amprows = []
        for(const c of puzzState.couplets){
            if(c.revealed){
                amprows.push("X")
                continue
            }
            let row = ""
            for(var i=0;i<(c.counter > 5 ? 5 : c.counter);i++){
                row += "&"
            }
            if(c.counter > 5) row += "+"
            amprows.push(row)
        }
        //let text = "A    —" + (d.getMonth()+1) + "." + (d.getDate()) + "—    \n";
        let text = "A    —" + puzzMonth + "." + puzzDay + "—    \n";
        text += "M   " + " ".repeat(6 - amprows[0].length) + amprows[0] + " ".repeat(6 - amprows[0].length) + "\n";
        text += "P    " + " ".repeat(6 - amprows[1].length) + amprows[1] + " ".repeat(6 - amprows[1].length) + "\n";
        text += "E    " + " ".repeat(6 - amprows[2].length) + amprows[2] + " ".repeat(6 - amprows[2].length) + "\n";
        text += "R  S  A  N  D  I\n"
        text += "\n"
        text += "https://" + location.host + "/?p=" + seqId

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            try{
                await navigator.share({text:text})
                //console.log("share complete")
            }catch(err) {
                //console.log("share error: " + err)
            }
        }else{
            navigator.clipboard.writeText(text).then(function() {
                confirmcopy = true
                setTimeout(()=>confirmcopy=false,2000)
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
    }

    function closeModal() {
        isOpenModal = false;
        dispatch('closeModal', { isOpenModal });
    }

</script>

{#if isOpenModal}
<div id="sharebackground" on:click={closeModal} transition:fade></div>
{#if confirmcopy}
<div id="copyconfirmation" aria-live="polite" transition:fade>Ampersandi result copied to your clipboard!</div>
{/if}
<div id="sharemodal" transition:fade>
    <div class="stats">
        {#each winhistory as hist (hist.label)}
            <div class="leftcol" class:highlight='{solved && !puzzState.revealed && puzzState.submissions == hist.label.length}'>{hist.label}</div>
            <div class:highlight='{solved && !puzzState.revealed && puzzState.submissions == hist.label.length}'>= {hist.count}</div>
        {/each}
    </div>
    {#if solved && puzzState.revealed}
        <hr>
        <h5>Womp womp.</h5>
        <h6>Puzzle revealed after {puzzState.submissions} tr{
                (puzzState.submissions == 1 ? "y" : "ies")
                + (puzzState.hintsUsed > 0 ? " and " + puzzState.hintsUsed + " hint" : "") 
                + (puzzState.hintsUsed > 1 ? "s":"") + "."
            }</h6>
        <button id="sharebutton" type="button" class="submitbtn" on:click={shareResult}><img src="images/share-svgrepo-com.svg" alt="share icon">Share</button>
        <p class="nextpuzzle">{daysleftstr}</p>
    {:else if solved}
        <hr>
        <h5>Congratulations!</h5>
        <h6>You solved it in {puzzState.submissions} tr{
                (puzzState.submissions == 1 ? "y" : "ies")
                + (puzzState.hintsUsed > 0 ? " and " + puzzState.hintsUsed + " hint" : "") 
                + (puzzState.hintsUsed > 1 ? "s":"") + "."
            }</h6>
        <button id="sharebutton" type="button" class="submitbtn" on:click={shareResult}><img src="images/share-svgrepo-com.svg" alt="share icon">Share</button>
        <p class="nextpuzzle">{daysleftstr}</p>
    {:else}
    <button type="button" class="submitbtn" on:click={closeModal} style="margin-top:10px">Close</button>
    {/if}
</div>
{/if}

<style>
    #sharebackground {
        display: block;
        position: fixed;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: var(--fg-color);
        opacity: 0.6;
    }
    #copyconfirmation {
        display: block;
        position: absolute;
        width: 200px;
        top: 50px;
        background: var(--bg-color);
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        color: var(--fg-color);
        z-index: 13;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        padding:10px;
    }
    #sharemodal {
        display: flex;
        position: absolute;
        padding:15px;
        z-index: 12;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: var(--bg-color);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        max-width:300px;
        width:100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    h5 {
        font-family: 'Georgia';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.18em;
        margin-top: 5px;
        margin-bottom: 5px;
        color: var(--fg-color);
        padding-top:0px;
    }
    h6 {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        letter-spacing: 0.18em;  
        color: var(--fg-color);
        margin-top: 5px;
        margin-bottom: 20px;
    }
    hr {
        width: 100%;
    }
    .stats{
        display:grid;
        width:100%;
        grid-template-columns: 50% 50%;
        color:var(--fg-color);
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 27px;

        color: var(--fg-color);
    }
    .stats .leftcol{
        text-align: right;
        margin-right:4px;
    }
    .stats .highlight{
        color: var(--accent);
        font-weight:700;
    }
    .submitbtn{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .submitbtn img{
        height: 20px;
        filter: invert(1);
        margin-right: 10px;
    }
    .darkmode .submitbtn img{
        height: 20px;
        filter: invert(0);
        margin-right: 10px;
    }
    .nextpuzzle {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 167.02%;
        /* identical to box height, or 17px */

        text-align: center;

        color: var(--fg-color);
    }
</style>